import { Collapse, Stack, useMediaQuery, useTheme } from '@mui/material';
import { CandidateNavbarUserDropdownMenu } from '../../../UserNavigationMenus/CandidateMenus/CandidateNavbarUserDropdownMenu';
import { CandidateNavBarAuthenticatedViewProps } from 'types/connectTypes';
import { JobSeekingStatusDropdown } from 'components/JobSeekingStatus/JobSeekingStatusDropdown';
import { MatchQuizButton } from 'components/NavBar/NavBarButtons/MatchQuizButton';
import { MatchQuizStatusStrings } from 'features/Connect/utils/connectEnums';
import { useBannerContext } from 'features/Connect/features/Context/BannerContextProvider';
import { BannerKeys } from 'utils/constants/banners';
import { useRouteMatch } from 'react-router-dom';
import { connectRedirectUrls } from 'utils/constants/urls';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';

export const CandidateNavBarAuthenticatedView: React.FC<CandidateNavBarAuthenticatedViewProps> = ({
  user,
  candidateMatches,
  matchQuizStatus,
  isFetchingMatchQuizStatus,
  isOnConnect,
  isCandidatePortal,
  isCandidateUser,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { currentBannerKey } = useBannerContext();
  const { jobSeekingStatus } = useConnectContext();

  const shouldRenderMatchQuizButton =
    isCandidateUser &&
    matchQuizStatus !== MatchQuizStatusStrings.COMPLETE &&
    currentBannerKey !== BannerKeys.MATCH_QUIZ;

  const isConnectProfilePage = useRouteMatch({ path: connectRedirectUrls.PROFILE, exact: true });
  const isConnectQualificationsPage = useRouteMatch({
    path: connectRedirectUrls.QUALIFICATIONS,
    exact: true,
  });
  const isConnectPreferencesPage = useRouteMatch({
    path: connectRedirectUrls.PREFERENCES,
    exact: true,
  });

  const isConnectProfileFlowPage =
    isConnectProfilePage || isConnectQualificationsPage || isConnectPreferencesPage;

  return (
    <Stack direction={'row'} gap={1} alignItems="center">
      {!isMobile &&
        !isFetchingMatchQuizStatus &&
        shouldRenderMatchQuizButton &&
        !isConnectProfileFlowPage && (
          <Collapse in={shouldRenderMatchQuizButton} timeout={300} unmountOnExit>
            <MatchQuizButton />
          </Collapse>
        )}
      {(isOnConnect || isCandidatePortal) && !isConnectProfileFlowPage && (
        <JobSeekingStatusDropdown
          userId={user.id}
          userJobSeekingStatus={jobSeekingStatus}
          width={{ xs: '180px', sm: '220px' }}
          autoSave
        />
      )}
      <CandidateNavbarUserDropdownMenu user={user} candidateMatches={candidateMatches} />
    </Stack>
  );
};
